import { FilterName, InterceptType } from '../../__generated__/fed-graphql-types'
import {
    shouldShowValuationIntercept,
    ValuationIntercept,
} from '../search-listing/intercept/valuation-intercept-content'
import {
    RelevanceSearchIntercept,
    shouldShowRelevanceIntercept,
} from '../search-listing/intercept/relevance-intercept-content'
import { Selected } from '../../forms/hocs/selected-options'
import { getItemLocalStorage, setItemLocalStorage } from '@at/window-utils/lib/local-storage-utils/local-storage.utils'

const SEARCH_INTERCEPT_LOCAL_STORAGE_KEY = 'searchIntercepts'

export function getInterceptStorage():
    | Record<InterceptType, RelevanceSearchIntercept[] | ValuationIntercept[]>
    | undefined
export function getInterceptStorage(
    interceptType: InterceptType.RELEVANCE_SEARCH
): RelevanceSearchIntercept[] | undefined
export function getInterceptStorage(interceptType: InterceptType.VALUATION): ValuationIntercept[] | undefined
export function getInterceptStorage(interceptType?: InterceptType) {
    const interceptStorage = getItemLocalStorage(SEARCH_INTERCEPT_LOCAL_STORAGE_KEY)
    if (!interceptStorage) return undefined
    try {
        const interceptData = JSON.parse(interceptStorage)
        if (interceptType) {
            switch (interceptType) {
                case InterceptType.RELEVANCE_SEARCH:
                    return interceptData.RELEVANCE_SEARCH ?? undefined
                case InterceptType.VALUATION:
                    return interceptData.VALUATION ?? undefined
            }
        }
        return interceptData
    } catch {
        return undefined
    }
}

export const setInterceptStorage = (
    interceptType: InterceptType,
    interceptData: ValuationIntercept | RelevanceSearchIntercept
) => {
    const interceptStorage = getInterceptStorage()
    let updatedIntercepts
    if (!interceptStorage) {
        updatedIntercepts = {
            [interceptType]: [interceptData],
        }
    } else {
        updatedIntercepts = {
            ...interceptStorage,
            [interceptType]: [...(interceptStorage[interceptType] ?? []), interceptData],
        }
    }
    setItemLocalStorage(SEARCH_INTERCEPT_LOCAL_STORAGE_KEY, JSON.stringify(updatedIntercepts))
}

export const showIntercept = (
    selectedFilters: Map<FilterName, Selected>,
    sortParam: string | undefined,
    interceptType: InterceptType | null | undefined
): boolean => {
    switch (interceptType) {
        case InterceptType.VALUATION:
            return shouldShowValuationIntercept(selectedFilters)
        case InterceptType.RELEVANCE_SEARCH:
            return shouldShowRelevanceIntercept(sortParam)
        default:
            return false
    }
}
